/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:15:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-07 11:58:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/ContentCategory/Node/index.tsx
 */
import React from 'react';
//import css from './css.module.less';
import { useDispatch } from 'react-redux';

import HOC from '../HOC';

// import Table from '../Table';
// import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
// import Top from 'src/pages/SalesChannelCategory/Components/Card';
import Card from 'src/pages/SalesChannelCategory/PagesCategory/ContentCategory/Card';

import { useI18n } from 'src/hooks/useRouterChange';
import GeneralModal from 'src/pages/SalesChannelCategory/Components/EditModal/General';
import {
  getOptions,
  submitChange,
} from 'src/pages/SalesChannelCategory/PagesCategory/ContentCategory/EditModal/tools';
import { i18nGet } from 'src/tools/tools';
import { onDataUpdate } from '../slice';

const Node = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const {
    data,
    moveList,
    salesChannelUuid,
    userPermissions,
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
  } = props;

  const {
    //path = [],
    uuid,

    name,
    urlSlug,
    parentUuid,
    fullUrl,
    contentVersion,
  } = data || {};

  const parentNode = moveList.find((i) => i.value === parentUuid);
  const parentName = parentNode ? parentNode.label : '';

  const handleOnDataUpdate = (data: any) => {
    _d(onDataUpdate({ data }));
    //onModalCancel();
  };

  //====request
  const optionsId = `postGetOptionsLegal${salesChannelUuid}`;
  const submissionId = `postCategoryProductLegal${salesChannelUuid}`;
  const requestId = [optionsId, submissionId];
  const _getOptions = ({ setOptions }) => {
    return getOptions({
      salesChannelUuid,
      selfUuid: uuid,
      requestId: optionsId,
      setOptions,
    });
  };
  const _submitChange = ({ urlSlug, parentUuid, name }) => {
    return submitChange({
      salesChannelUuid,
      selfUuid: uuid,
      requestId: submissionId,
      urlSlug,
      parentUuid,
      name,
      onOk: handleOnDataUpdate,
    });
  };
  //===request

  const onEdit = () => {
    setModalTitle(getI18n('salesChannelCategoryPages.index.editCategory'));

    setModalContent(
      <GeneralModal
        onGetOptions={_getOptions}
        onSubmit={_submitChange}
        requestId={requestId}
        slugCheckingUrl={'portal/salesChannel/category/content/checkUrlSlug'}
        onOk={handleOnDataUpdate}
        salesChannelUuid={salesChannelUuid}
        onCancel={onModalCancel}
        name={name}
        parentUuid={parentUuid}
        urlSlug={urlSlug}
        contentVersion={contentVersion}
        uuid={uuid}
        isSlugRequired={false}
        isPage
      />,
    );

    setShowModal(true);
  };

  return (
    <React.Fragment>
      <Card
        canEdit={userPermissions.canCreate}
        onEdit={onEdit}
        contentList={[
          [
            {
              label: getI18n('salesChannelCategoryPages.index.pageName'),
              value: name,
            },
            {
              label: getI18n('salesChannelCategoryPages.index.contentVersion'),
              value: contentVersion,
            },
          ],
          [
            {
              label: getI18n('salesChannelCategoryPages.index.parent'),
              value: parentName,
            },
            {
              label: getI18n('general.uRLSlug'),
              value: urlSlug || '-',
            },
          ],
          [
            {
              label: getI18n('general.uRL'),
              value: fullUrl,
            },
            {
              label: '',
              value: '',
            },
          ],
        ]}
        // name={name}
        // slug={urlSlug}
        // url={fullUrl}
        // parent={parentName}
        // isRoot={isRoot}
        // contentVersion={contentVersion}
      />
    </React.Fragment>
  );
};

export default HOC(Node, {});
